/* Using a self-executing anonymous function - (function(){})(); - so that all variables and functions defined within 
aren’t available to the outside world. */

(function(){
  
/* Load Script function we may need to load jQuery from the Google's CDN */
/* That code is world-reknown. */
/* One source: http://snipplr.com/view/18756/loadscript/ */

var loadScript = function(url, callback){
 
  var script = document.createElement("script");
  script.type = "text/javascript";

  // If the browser is Internet Explorer.
  if (script.readyState){ 
    script.onreadystatechange = function(){
      if (script.readyState == "loaded" || script.readyState == "complete"){
        script.onreadystatechange = null;
        callback();
      }
    };
  // For any other browser.
  } else {
    script.onload = function(){
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
    
};

/* This is my app's JavaScript */
var myAppJavaScript = function($){
  // $ in this scope references the jQuery object we'll use.
  // Don't use jQuery, or jQuery191, use the dollar sign.
  // Do this and do that, using $.
  
  //$('body').append('<p>Your app is using jQuery version '+$.fn.jquery+'</p>');
  
  
 //Build a pseudo-class to prevent polluting our own scope.
	var api = {
		Settings: {
          
          	FreeItemVariantId : 48051967949,
		            
          FreeproductId : '48051967949',
          FreeAfterCartTotal : 5499.0,
          OfferForVendorName : 'Syntrax',
          IsEnable : true,
          FreeItemURL : 'https://store.bariatricpal.com/products/syntrax-aerobag-sling-bag-free-offer',
          IsProp65Enable : true,
          Prop65Tag : "prop65",
          Prop65Title : 'WARNING: California&#39;s Proposition 65',
          iplookdomain : "https://appbundle.bariatricpal.com/Home/iplookupmain",
          iplookdomain1 :"https://geoip.sezzle.com/v1/geoip/ipdetails",
          StateProvinceKey : "state" + new Date().getDate() + new Date().getMonth() + new Date().getFullYear(),
          CartData: null,
          O_B_Eligi_ProductId: 7543419457,
          O_B_Free_VariantId : 32160080887885,
          O_B_Eligi_CollectionId: 424358541,
          O_B_Free_OF2VariantId : 28190363254861,
          O_B_OF2_Col_Data : {},
      	  Box12Month : 00000000000000000000000010010,
      	  Box12MonthFreeScaleProductID : 00000000000000000000000010010,
      	  FreeScaleItemURL: 'https://store.bariatricpal.com/products/yunmai-mini-wireless-bluetooth-smart-scale-10-body-measurements-3-colors.json'
      
        },
      	IpLookUpOutsideService : function(){
      	
          if(typeof Rebuy == "object" && typeof Rebuy.getGeolocation == "function"){
          	Rebuy.getGeolocation().then(res => {
                console.log(res);
              var json = res; 
              json.country = res.country_name;
              json.city = res.city_name;
              json.region = res.province_name;
              json.state_prov = res.province_name;
              
              if (json.country && json.city) {
                           if(json.city.toLowerCase() == "california"){
                           		window["MyStoreWidget"].warningForCalifornizaCelebrateProducts(json.city);
                           }
                           else if(json.region == "California"){
                           		window["MyStoreWidget"].warningForCalifornizaCelebrateProducts(json.region);
                           }else if(json.state_prov == "California"){
                           		window["MyStoreWidget"].warningForCalifornizaCelebrateProducts(json.state_prov);
                           }
                         }
              
            }, failure => {
                console.error(failure); //expected output: Oopsy...
            })
          }
          else{
            
            if(localStorage.getItem(window["MyStoreWidget"].Settings.StateProvinceKey) == undefined){
            
      				$.getJSON(window["MyStoreWidget"].Settings.iplookdomain,
                        function(json) {
              
                          if(json.country && json.region){                            	
                                let califonia = "california";
                                if(json.regionName.toLowerCase() == califonia || json.city.toLowerCase() == califonia){
                                  	localStorage.setItem(window["MyStoreWidget"].Settings.StateProvinceKey,califonia);
                                    window["MyStoreWidget"].warningForCalifornizaCelebrateProducts(califonia);
                                }else{
                                	localStorage.setItem(window["MyStoreWidget"].Settings.StateProvinceKey,json.regionName.toLowerCase());
                                }
                          }
              			
                  	});
            }else if(localStorage.getItem(window["MyStoreWidget"].Settings.StateProvinceKey) == "california"){
            	window["MyStoreWidget"].warningForCalifornizaCelebrateProducts("california");
            }
          }
      	},
      	showCaliforniaCustomerWarning : function(){
          
          	window["MyStoreWidget"].IpLookUpOutsideService();
          	return;
             
        },
        warningForCalifornizaCelebrateProducts : function(province) {
          	if(province != null && (province.toLowerCase() == "california")){
                var msg='<div id="warning-celebrate"><b><img src="https://cdn.shopify.com/s/files/1/0806/1189/files/warningicon.png?v=1715173312" alt="California Proposition 65 warning" class="img-prop65warning"/> '+ window["MyStoreWidget"].Settings.Prop65Title  +':</b> Consuming this product can expose you to chemicals including lead, which is known to the State of California to cause cancer and birth defects or other reproductive harm.  For more information go to <a target="_blank" class="link link--accented" href="https://www.P65Warnings.ca.gov/food">www.P65Warnings.ca.gov/food.</a></div>';
                // add this message for california based visitor and Celebrate Vitamins brand products.
                //$(".product-block-list__item--description").append(msg);
                document.querySelectorAll(".product-block-list__item--description").forEach(function(element) {
                    element.insertAdjacentHTML('beforeend', msg);
                });



                if($("body").hasClass("cart")){  
                  if($("#warning-celebrate").length == 0){
                  	msg='<div id="warning-celebrate" style="max-width:90%;margin:0px auto 10px auto;" ><div><b><img class="img-prop65warning" src="https://cdn.shopify.com/s/files/1/0806/1189/files/warningicon.png?v=1715173312" alt="California Proposition 65 warning"/> '+ window["MyStoreWidget"].Settings.Prop65Title  +':</b> Consuming these products can expose you to chemicals including lead, which is known to the State of California to cause cancer and birth defects or other reproductive harm. For more information go to <a href="https://www.P65Warnings.ca.gov/food" class="link link--accented" target="_blank">www.P65Warnings.ca.gov/food</a>.</div></div>';
                    $("footer").prepend(msg);
                  }
                }
            }  
      	},
      	IsCorrectPlaceForProp65 : function(){
      		// If product page, Cart page or Checkout page.
          if(window.location.href.indexOf("/products") > -1){
          	return true;
          }else if(window.location.href.indexOf("/cart") > -1){
          	return true;
          }else if(window.location.href.indexOf("/checkout") > -1){
          	return true;
          }
          return false;
      	},
      	Prop65TagProcessStart: function(){
      		
          if(window["MyStoreWidget"].IsCorrectPlaceForProp65()){
          	// Check products Tags and based on it, Display PROP65 related message.
            if(window.location.href.indexOf("/products") > -1){  
              var tempu = window.location.href.toString().replace(window.location.search,"");
				
              $.getJSON(tempu+".json",function(r){ var e = window["MyStoreWidget"].CheckTagsOfProduct(r); 
                                                         if(e){  
              		window["MyStoreWidget"].AddProp65Message("p");
              	} });
            }else if(window.location.pathname.includes("/cart")){
              $.getJSON("/cart.json",function(ct){ 
                	// Whole Cart. check Items
                	var onceDisplayed=false;
                	$(ct.items).each(function(index,item){
                      	var tempurl = item.url.split("?")[0];
                      	// Get product details, check tags.                      	
                      	$.getJSON(tempurl+".json",function(r){ 
                          		
                                var e1 = window["MyStoreWidget"].CheckTagsOfProduct(r); 
                          		if(e1 == true) { 
                                  if(onceDisplayed == false){
                                    window["MyStoreWidget"].AddProp65Message("c"); 
                                  }
                                  onceDisplayed = true;
                                }
                                                      	
                        });
                	});
                
                                                   
				});
            }
          	
          }
          
      	},
      	AddProp65Message : function(pagetype){
          if(pagetype == "p" || pagetype == "c"){
          		// product page message.
            	
            	window["MyStoreWidget"].showCaliforniaCustomerWarning();
          }
      	},
      	CheckTagsOfProduct : function(pobj){ 
      		var tags = pobj.product.tags.split(",");
          	var exists = false; 
              tags.filter(function(item,index){ 
            	if($.trim(item).toLowerCase() == window["MyStoreWidget"].Settings.Prop65Tag){
          			exists=true;
          		} 
          	});
          	
          	return exists;
      	},
      	Start: function () {
          
			//The start function handles widget initialization.
          // Check for cart items. Is total above than mentioned, Is OfferForVendorName item available in cart items.
          this.LoadCartItems(function (data) {
          	
            window["MyStoreWidget"].FreeitemsShouldNotAllowQuantityBox();
            
            var isEligible = window["MyStoreWidget"].IsOfferEligibleForVendor(data); 
            var q = window["MyStoreWidget"].GetFreeItemsQuantity(data);
            if (isEligible){
            	
              
              if(q == 0){                	
                
                  window["MyStoreWidget"].AddUpdateFreeItem(q);
              
              }else if(q > 1){                	                
                	// Remove all quantity and set 1.
                window["MyStoreWidget"].RemoveAllQuantity(function(){ window["MyStoreWidget"].AddUpdateFreeItem(0) });
                	
              }else if(q == 1){                	
                window["MyStoreWidget"].IsFreeItemPropertieExists(data); 
              }
              
            }else if(q > 0 && isEligible == false){
            
              	var r = window["MyStoreWidget"].IsFreePropertieExists(data);
                if(r == true){
                  $.post('/cart/change.js', {
                    quantity: 0,
                    id: window["MyStoreWidget"].Settings.FreeItemVariantId
                  }).always(function() {
                      window.location.reload();
                  });
              	}
            }
            
          });
          
		},
      	RemoveAllQuantity : function(callback){
        	var onedata = {
                        "quantity": 0,
              			"id": window["MyStoreWidget"].Settings.FreeItemVariantId
            			};
          	              	
                
                  $.post('/cart/change.js',  onedata).always(function() {
                      callback();
                  });
            
        },
      	AddUpdateFreeItem : function(q){
          		// Add or Change Quantity of Free Item.
              	var onedata = {
                        "quantity": 1,
                        "id": window["MyStoreWidget"].Settings.FreeItemVariantId,
                         properties: {
                           '_Offer': 'FREE GIFT'
                        }
                      };
          	if(q == 0){                	
                
                  $.post('/cart/add.js',  onedata).always(function(r) {
                    if(r.status == 422){ 
                    	console.log("PRODUCT NOT AVAILABLE.");
                    }else{
                    	window.location.reload();
                    }
                  });
              
              }else if(q > 1){                	
                
              	$.post('/cart/change.js', onedata).always(function() {
                  	window.location.reload();
              	});
              }
      	
      	},
        IsFreePropertieExists : function(data){
          	var items = data.items;
          	var rtn = false;
      		items.forEach(function(e,i,a) {
              	 var currentVarId = e.variant_id;
                 if(currentVarId == window["MyStoreWidget"].Settings.FreeItemVariantId && e.properties._Offer != null) {
                   rtn = true;
                 }
            });
          
          	return rtn;          
      	},
      	IsFreeItemPropertieExists : function(data){
          	var items = data.items;
      		items.forEach(function(e,i,a) {
              	 var currentVarId = e.variant_id;
                 if(currentVarId == window["MyStoreWidget"].Settings.FreeItemVariantId && e.properties._Offer == null) {
                   var onedata = {
                        "quantity": 0,
                        "id": window["MyStoreWidget"].Settings.FreeItemVariantId,
                         properties: {}
                   };
                   	// Item present but Properly does not exists.                   	
                   	$.post('/cart/change.js', onedata).always(function() {                      
						window["MyStoreWidget"].AddUpdateFreeItem(0);                    
              		});
                 }
            });
          
      	},
      	FreeitemsShouldNotAllowQuantityBox : function () {      		
          	$("input[id*=updates_"+  window["MyStoreWidget"].Settings.FreeItemVariantId +"]").attr("readonly","true");
          
      	},		
		LoadCartItems: function (callback) {
			
          $.getJSON('/cart.js', function(data){ callback(data); });
          
		},
      	GetFreeItemsQuantity: function(data){
      		var items = data.items;
          	var qty = 0;
          	items.forEach(function(e,i,a) {
              	 var currentVarId = e.variant_id;
                 if(currentVarId === window["MyStoreWidget"].Settings.FreeItemVariantId) {
                   	qty = e.quantity;
                 }
            });
          
          	return qty;
      	},
      	// FreeAfterCartTotal is configured in the shop's base currency, but /cart.js totals
      	// come back in the customer's active display currency. Shopify.currency.rate (set
      	// when the storefront currency switcher is active) gives the live conversion rate.
      	GetShopCurrencyRate : function(){
      		if(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate){
      			var r = parseFloat(window.Shopify.currency.rate);
      			if(!isNaN(r) && r > 0){ return r; }
      		}
      		return 1;
      	},
      	GetFreeAfterCartTotalConverted : function(){
      		return Math.round(window["MyStoreWidget"].Settings.FreeAfterCartTotal * window["MyStoreWidget"].GetShopCurrencyRate());
      	},
      	IsOfferEligibleForVendor : function(data){
      		var items = data.items;
          	var isEligible = false;

          	if(window["MyStoreWidget"].Settings.IsEnable == false){
            	// Offer is not enabled. Remove item from Cart.
            	return false;
            }

          	// Not Eligible for Auto Renew / Subscription items.
          	var subscriptionItems = items.filter(function(item,index){ if(item.title.endsWith("Auto renew")){ return item;} })
            if(subscriptionItems.length > 0){
              return false;
            }

          	var freeAfterCartTotal = window["MyStoreWidget"].GetFreeAfterCartTotalConverted();

          if(data.total_price >= freeAfterCartTotal){

            var ttl = 0;
            items.filter(function(item,index) {
              	if(item.vendor == window["MyStoreWidget"].Settings.OfferForVendorName)
                {
                 	ttl += item.final_line_price;
                }
            });

            if(ttl >= freeAfterCartTotal){
            	isEligible = true;
            }


            return isEligible;
          }else {
          	return false;
          }
      	},
      	IsProductAvailable : function(product){
      		 
            	var lowpriceObj=null;	
              	product.variants.filter(function(item,index){ if(item.inventory_quantity < 1){ if(lowpriceObj == null){ lowpriceObj = item; } else if(parseFloat(lowpriceObj.price) > parseFloat(item.price)){ lowpriceObj = item; } } });
				
              	if(lowpriceObj != null){
                	return false;
                }else{
                	return true;
                }
      	},
      	StartFreeVendor : function(){
        	$.getJSON(window["MyStoreWidget"].Settings.FreeItemURL + '.json',function (r){      
              if(window["MyStoreWidget"].IsProductAvailable(r.product))
              {
                    //Start the widget
                    window["MyStoreWidget"].Start();
              }
            });
        },
          BoxOfMonthFreeItem : function(){
          	// check Cart data and if not exists then Add it. Only add if Box of Month 12 month Subscription item is added into the Cart.
            var box12month = window["MyStoreWidget"].Settings.CartData.items.find(s=>s.variant_id == window["MyStoreWidget"].Settings.Box12Month);	
            var box12monthFreeScale = window["MyStoreWidget"].Settings.CartData.items.find(s=>s.product_id == window["MyStoreWidget"].Settings.Box12MonthFreeScaleProductID && s.properties._Offer != null);	
              
            if(box12month != null){
              if(box12monthFreeScale == null){
              	// Check availability then add 
                $.getJSON(window["MyStoreWidget"].Settings.FreeScaleItemURL,function (r){
      				
                	var vprod = r.product.variants.find(s=>s.inventory_quantity > 0);
                  	if(vprod != null){
                    	window["MyStoreWidget"].AddUpdateItemInCart(0, vprod.id);
                  	}
                });
                
              }
            }else if(box12month == null && box12monthFreeScale != null) {
              window["MyStoreWidget"].RemoveItemFromCart(box12monthFreeScale.variant_id, function(){ 
              		
              });    	
            }
          },
          CallrefreshFreeItemBar : function(data){

            if(typeof refreshFreeItemBar == "function"){              
            	var totalPrice = data.total_price;
              var giftAmt = 0; data.items.forEach(function(item){ if(item.gift_card){ giftAmt += item.final_line_price; } });
              var boxofmonthAmt = 0; data.items.forEach(function(item){ if(item.product_type == "Subscription Box"){ boxofmonthAmt += item.final_line_price; } });	 	
              	
              var isFreeitemadded = false; data.items.forEach(function(item){ if(item.properties && item.properties["_OfferItem"] != null){ isFreeitemadded = true; } });
               if( data.items.filter(d=>d.product_type == "Subscription Box").length >= 1 && 
                  data.items.filter(d=>d.product_type != "Subscription Box").length == 0 )
              {
                  isFreeitemadded = true; 
              }
              	if(data.items.filter(d=>d.product_type == "Subscription Box").length >= 1)
                {        	
                    giftAmt = giftAmt + boxofmonthAmt;
                }
              
    			    refreshFreeItemBar(data.total_price - giftAmt, isFreeitemadded);
            }
          },
          CartUpdatedEvent : function(cart){
        	// Call again same methods.  
          	window["MyStoreWidget"].Settings.CartData = cart; 
        
            var giftAmt = 0; cart.items.forEach(function(item){ if(item.gift_card){ giftAmt += item.final_line_price; } });
            var boxofmonthAmt = 0; cart.items.forEach(function(item){ if(item.product_type == "Subscription Box"){ boxofmonthAmt += item.final_line_price; } });	 	
              
            
            window.globalCartTotal = cart.total_price - giftAmt - boxofmonthAmt;
            window["MyStoreWidget"].CallrefreshFreeItemBar(cart);

            // Box of Month Free Scale Adding
          	window["MyStoreWidget"].BoxOfMonthFreeItem();
            
            // Start Free Book Offer. 
  			window["MyStoreWidget"].StartFreeBookOfferProduct();  
            window["MyStoreWidget"].StartFreeVendor();
            
            
        },
      StartFreeBookOfferProduct : function(){
      		// Free product url 
        	// Collection wise ? or Necessary Product Checking.
        	// Add/Update/Delete free item.
        	
        	//1. check for eligibilty item
        	var isEligible = false;
        	var eligiProd = window["MyStoreWidget"].Settings.CartData.items.find(s=>s.product_id == window["MyStoreWidget"].Settings.O_B_Eligi_ProductId);	
        	if(eligiProd != null){
        		// Check cart, if free book item not exists then add one. 
              	var freeProd = window["MyStoreWidget"].Settings.CartData.items.find(s=>s.variant_id == window["MyStoreWidget"].Settings.O_B_Free_VariantId && s.properties._Offer != null);	
              	if(freeProd == null){
                  	window["MyStoreWidget"].AddUpdateItemInCart(0, window["MyStoreWidget"].Settings.O_B_Free_VariantId);
                }
            }else {
            	// Check for free item, if exists then remote it. 
             	var freeProd = window["MyStoreWidget"].Settings.CartData.items.find(s=>s.variant_id == window["MyStoreWidget"].Settings.O_B_Free_VariantId && s.properties._Offer != null);	
              	if(freeProd != null){
                  	window["MyStoreWidget"].RemoveItemFromCart(window["MyStoreWidget"].Settings.O_B_Free_VariantId,function(){
                    	// Remove its UI from screen.
             			$("section a[data-vid='"+ window["MyStoreWidget"].Settings.O_B_Free_VariantId +"']").closest(".section").remove();         	
                    });
                }
            }
      	},
      	RemoveItemFromCart : function(vid,callback){
        	var onedata = {
                        "quantity": 0,
              			"id": vid
            };            	
                
            $.post('/cart/change.js',  onedata).always(function() {
            	callback();
            });
            
        },
      	AddUpdateItemInCart : function(q, vid){
          		// Add or Change Quantity of Free Item.
              	var onedata = {
                        "quantity": 1,
                        "id": vid,
                         properties: {
                           '_Offer': 'FREE GIFT'
                        }
                      };
          	
          	if(q == 0){                	
                
              		$.ajax({
                        url: '/cart/add.js',
                        dataType: 'json',
                        cache: false,
                        type: 'post',
                        data: onedata,
                      	complete: function (data) {
                          	
                      		window["MyStoreWidget"].UpdateCartUI();
                      	}
                    });
              
              }else if(q > 1){                	
                
              	/*$.post('/cart/change.js', onedata).always(function(r) {
                  	if(r.status == null){
                    	 window["MyStoreWidget"].UpdateCartUI();
                    }
              	});*/
                
                $.ajax({
                        url: '/cart/change.js',
                        dataType: 'json',
                        cache: false,
                        type: 'post',
                        data: onedata,
                      	complete: function (r) {
                      		window["MyStoreWidget"].UpdateCartUI();
                      	}
                    });
                
              }
      	
      	},
        UpdateCartUI : function(){
            $.get("/cart",function(r){ 
              $("#cart_form .itemlist").html($(r).find("#cart_form .itemlist").html());
			});
          	
        },
        FetchProductsListofCollection : function(colid,callbackf){

          var coldata = JSON.parse(localStorage.getItem("msw_collect"));
          if(coldata != null){
          	callbackf(coldata);
          }
          $.getJSON('/admin/collects.json?collection_id='+ colid +'&fields=product_id,collection_id',function (r){
				var coldata = r;
            	localStorage.setItem("msw_collect", JSON.stringify(coldata));
          		callbackf(r);
          });
        }
	};

  	//Optionally make the api available to the global scope for debugging.
	window["MyStoreWidget"] = api;

  	if(window["MyStoreWidget"].Settings.IsProp65Enable){
  		window["MyStoreWidget"].Prop65TagProcessStart();
  	}
  
  	$.getJSON('/cart.js', function(data){ 
      	// Start Free Book Offer. 
  		window["MyStoreWidget"].CartUpdatedEvent(data);
	});
	//Optionally make the api available to the global scope for debugging.
	window["MyStoreWidget"] = api;
  
};

/* If jQuery has not yet been loaded or if it has but it's too old for our needs,
we will load jQuery from the Google CDN, and when it's fully loaded, we will run
our app's JavaScript. Set your own limits here, the sample's code below uses 1.7
as the minimum version we are ready to use, and if the jQuery is older, we load 1.9. */
if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js', function(){
    jQuery191 = jQuery.noConflict(true);
    myAppJavaScript(jQuery191);
  });
} else {
  myAppJavaScript(jQuery);
}

})();
